import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowForward, IoMdEyeOff } from "react-icons/io";
import { calculateFileSize } from "./helper";
import { FaDownload, FaEye } from "react-icons/fa";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import Share from "../../components/ShareEmaileFax/Share";
import { getBaseUrl } from "../../helper";
import ConvertStringToHtml from "../../components/ConvertStringToHtml";

function ProcessedDataComponent({
  processedDataList,
  setProcessedDataList,
  selectedChat,
  attachDocumentHandler,
  processedLoading,
}) {
  const { auth: authToken } = JSON.parse(localStorage.getItem("auth"));
  const [shareDialog, setShareDialog] = useState({
    state: false,
    fileData: null,
  });
  const downloadHandler = (uuid) => {
    if (uuid) {
      let url = `${getBaseUrl()}/utilities/get_attachment.json?attachment=${uuid}&token=${authToken}&download=1&practice_id${
        selectedChat?.pid
      }=&tz=${new Date().getTimezoneOffset()}`;
      window.open(url, "_blank");
    } else {
      toast.error("File Id not Found");
    }
  };
  return (
    <div>
      {shareDialog?.state && (
        <Share
          from={"document"}
          sharePreviewUrl={"messages/read_attachment?uuid"}
          printData={"printData"}
          setShowShareeFax={setShareDialog}
          shouldCallPrepareDataApi={false}
          userUniqueId={{
            uuid: shareDialog?.fileData?.file_uuid,
            title: "document",
          }}
          hasFileData={{
            ...shareDialog?.fileData,
            details: [
              {
                content: shareDialog?.fileData?.file_uuid,
                page_count: shareDialog?.fileData?.page_count,
                filesize: shareDialog?.fileData?.filesize,
                mime_type: "application/pdf",
                order: 1,
                title: "Preview",
                type: "file",
              },
            ],
          }}
        />
      )}
      <div className="grid grid-cols-5 bg-teal1000 text-white px-3 py-1">
        <div>Generated On</div>
        <div>Generated By</div>
        <div>File</div>
        <div>Status</div>
        <div></div>
      </div>
      {processedLoading && <i className="text-center">Loading...</i>}
      {processedDataList?.map((v, k) => (
        <>
          <div className="grid grid-cols-5 px-3 py-2 border flex items-center">
            <div className="flex items-center cursor-pointer select-none">
              <span
                onClick={() => {
                  let processList = cloneDeep(processedDataList);
                  processList[k].toggle = !processList[k].toggle;
                  setProcessedDataList(processList);
                }}
              >
                {v?.toggle ? (
                  <IoIosArrowDown size={20} />
                ) : (
                  <IoIosArrowForward size={20} />
                )}
              </span>
              {moment(v?.ShareDataTransaction?.created).format(
                "MM/DD/YYYY hh:mm A"
              )}
            </div>
            <div>{v?.SharedBy?.fname + " " + v?.SharedBy?.lname}</div>
            <div className="text-sky-500 cursor-pointer">
              (<span>{v?.ShareDataTransaction.page_count} pages, </span>
              {calculateFileSize(v?.ShareDataTransaction?.filesize)})
            </div>
            <div className="capitalize">{v?.ShareDataTransaction?.status}</div>
            <div className="flex">
              {/* <div
                className="bg-teal1000 px-3 py-1 text-white cursor-pointer mr-2"
                onClick={() =>
                  downloadHandler(v?.ShareDataTransaction?.file_uuid)
                }
              >
                <FaDownload />
              </div>
              <div
                className="bg-teal1000 px-3 py-1 text-white cursor-pointer"
                onClick={() => {
                  let data = v?.ShareDataTransaction;
                  console.log(data, "heree");
                  setShareDialog({
                    state: true,
                    fileData: v?.ShareDataTransaction,
                  });
                }}
              >
                Share
              </div> */}
              <div
                className="bg-teal1000 px-3 py-1 text-white cursor-pointer mr-2"
                onClick={() => {
                  attachDocumentHandler(v?.ShareDataTransaction);
                }}
              >
                Attach Document
              </div>
            </div>
          </div>
          <>
            {v?.toggle && (
              <div className="border-4 divide-y-2 text-left">
                {v?.ShareDataTransaction?.details?.length > 0 &&
                  v?.ShareDataTransaction?.details?.map((detailData) => (
                    <div className=" grid grid-cols-5 px-3 py-2 flex items-center">
                      <div className="col-span-2">{<ConvertStringToHtml msg={detailData?.title}/>}</div>
                      <div>{detailData?.type}</div>
                      <div className="flex ml-4">
                        {detailData?.file_uuid ? (
                          <>
                            <FaEye
                              onClick={() => {
                                window.open(
                                  `${
                                    process.env.REACT_APP_API_URL_V1
                                  }/utilities/get_attachment.json?attachment=${
                                    detailData?.file_uuid
                                  }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`,
                                  "_blank"
                                );
                              }}
                              size={20}
                              className="text-sky-700 cursor-pointer"
                            />
                          </>
                        ) : (
                          <>
                            <IoMdEyeOff size={20} />
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </>
        </>
      ))}
    </div>
  );
}

export default ProcessedDataComponent;
